import React, {useEffect, useState} from "react";
import AsyncSelect from 'react-select/async';
import {Form} from "react-bootstrap";
import {genericSelectGetAll} from "../pages/generic/crud";
import {useThemeMode, systemMode} from "../../_metronic/partials/layout/theme-mode/ThemeModeProvider";

export function AGCSelect({entityId, formik, isMulti, name, toolTip = "", value,
                              id, forUpdate = false, required = true, showAll = false, showAllText = "All",
                              filterField = null, filterValue = null, onChange}) {
    const [dataList, setDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const {mode} = useThemeMode();

    // Determine if dark mode is active
    const isDarkMode = mode === 'dark' || (mode === 'system' && systemMode === 'dark');

    if (toolTip === "") {
        toolTip = "Select " + name;
    }

    const handleChange = (option) => {
        if (onChange) {
            onChange(option);
        } else if (formik && id) {
            formik.setFieldValue(id, option);
        }
    };

    // Custom styles for dark theme
    const customStyles = isDarkMode ? {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: '#1e1e2d',
            borderColor: state.isFocused ? '#009ef7' : '#2b2b40',
            color: '#a1a5b7',
            '&:hover': {
                borderColor: '#009ef7'
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#1e1e2d',
            border: '1px solid #2b2b40'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#2b2b40' : '#1e1e2d',
            color: '#a1a5b7',
            '&:hover': {
                backgroundColor: '#2b2b40'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        input: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#6c7293'
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#2b2b40'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#a1a5b7'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#a1a5b7',
            '&:hover': {
                backgroundColor: '#3b3b54',
                color: '#ffffff'
            }
        })
    } : {};

    useEffect(() => {
        genericSelectGetAll(entityId, filterField, filterValue).then(({data}) => {
            const safeData = Array.isArray(data) ? data : [];
            let dataListWithAll = safeData;
            if (showAll) {
                dataListWithAll = [{id: 9999, name: showAllText}, ...safeData];
            }

            setDataList(dataListWithAll);
        }).catch(() => {
            setIsLoading(false);
        });
    }, [entityId, filterField, filterValue]);

    const loadOptions = (inputValue, callback) => {
        if (!Array.isArray(dataList)) {
            callback([]);
            return;
        }
        const filteredOptions = dataList.filter(option =>
            option.name && option.name.toLowerCase().includes(inputValue.toLowerCase())
        );

        callback(filteredOptions);
    };

    return (
        <>
            <Form.Label className={required ? 'required' : ''}>{name}</Form.Label>
            <AsyncSelect
                isMulti={isMulti}
                defaultOptions={dataList}
                value={value}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                inputValue={inputValue}
                onInputChange={setInputValue}
                loadOptions={loadOptions}
                isDisabled={forUpdate}
                onChange={handleChange}
                styles={customStyles}
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
